// File: frontend/src/pages/Privacy.js
//
// Public Privacy Notice page at /privacy. No authentication required.
//
// The CONTENT lives in src/content/privacyPolicy.js — the single source of
// truth that also generates docs/legal/PRIVACY_POLICY.md. The LAYOUT lives in
// components/legal/LegalDocument.js, shared with the Terms of Service at
// /terms so the two public legal pages cannot drift apart. This file only
// wires the two together.

import React from "react";
import LegalDocument from "../components/legal/LegalDocument";
import {
  POLICY_TITLE,
  POLICY_VERSION,
  POLICY_LAST_UPDATED,
  POLICY_EFFECTIVE_DATE,
  SECTIONS,
} from "../content/privacyPolicy";

export default function Privacy() {
  return (
    <LegalDocument
      metaTitle="Privacy Notice | PesaFii"
      metaDescription="How PesaFii collects, uses, shares and protects personal data across the dashboard, Mobile Money payments and hotspot captive portals."
      title={POLICY_TITLE}
      version={POLICY_VERSION}
      effectiveDate={POLICY_EFFECTIVE_DATE}
      lastUpdated={POLICY_LAST_UPDATED}
      indexAriaLabel="Sections of this notice"
      indexHeading="In this notice"
      sections={SECTIONS}
    />
  );
}
